<div class="auth-container">
    <div class="texture-top"></div>
    <div class="auth-warpper d-flex w-100 h-100 align-items-center justify-content-center">
        <div class="login-component-form position-relative" [ngClass]="!isReset ? 'is-reset' : ''">
            <img class="logo-icon" src="../../../../assets/images/logo-icon.png" alt="logo icon" />

            <div class="form-control" *ngIf="step == 'reset-your-password'">
                <h3 class="algin-center font-bold txt-welcome-back">{{ 'ResetPassword.Title' | translate }}</h3>
                <p class="algin-center line-text hidden-sm">{{ 'ResetPassword.Detail_line_1' | translate }}</p>
                <p class="algin-center line-text hidden-sm">{{ 'ResetPassword.Detail_line_2' | translate }}</p>
                <p class="algin-center line-text hidden-xs">
                    {{ 'ResetPassword.Detail_line_1' | translate }} {{ 'ResetPassword.Detail_line_2' | translate }}
                </p>
                <form class="form-auth" (ngSubmit)="resetPassword(myForm)" #myForm="ngForm" novalidate>
                    <div class="w-100 p-0 password-input position-relative">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.62492 18.4583C4.23603 18.4583 3.9027 18.3159 3.62492 18.0312C3.34714 17.7465 3.20825 17.4097 3.20825 17.0208V8.08329C3.20825 7.68051 3.34714 7.34024 3.62492 7.06246C3.9027 6.78468 4.23603 6.64579 4.62492 6.64579H5.97909V4.77079C5.97909 3.64579 6.37145 2.69093 7.15617 1.90621C7.94089 1.12149 8.88881 0.729126 9.99992 0.729126C11.111 0.729126 12.0589 1.12149 12.8437 1.90621C13.6284 2.69093 14.0208 3.64579 14.0208 4.77079V6.64579H15.3749C15.7638 6.64579 16.0971 6.78468 16.3749 7.06246C16.6527 7.34024 16.7916 7.68051 16.7916 8.08329V17.0208C16.7916 17.4097 16.6527 17.7465 16.3749 18.0312C16.0971 18.3159 15.7638 18.4583 15.3749 18.4583H4.62492ZM7.41659 6.64579H12.5833V4.77079C12.5833 4.03468 12.3333 3.41663 11.8333 2.91663C11.3333 2.41663 10.7221 2.16663 9.99992 2.16663C9.2777 2.16663 8.66659 2.41663 8.16659 2.91663C7.66659 3.41663 7.41659 4.03468 7.41659 4.77079V6.64579ZM4.62492 17.0208H15.3749V8.08329H4.62492V17.0208V17.0208ZM9.99992 14.1666C10.4444 14.1666 10.8228 14.0104 11.1353 13.6979C11.4478 13.3854 11.6041 13.0208 11.6041 12.6041C11.6041 12.1875 11.4478 11.809 11.1353 11.4687C10.8228 11.1284 10.4444 10.9583 9.99992 10.9583C9.55547 10.9583 9.177 11.1284 8.8645 11.4687C8.552 11.809 8.39575 12.1875 8.39575 12.6041C8.39575 13.0347 8.552 13.4027 8.8645 13.7083C9.177 14.0138 9.55547 14.1666 9.99992 14.1666Z"
                                fill="#ACACAC"
                            />
                        </svg>
                        <input
                            type="password"
                            class="input-text"
                            [ngClass]="
                                (newPasswordCtrl.hasError('required') ||
                                    newPasswordCtrl.hasError('isValidPassword') ||
                                    newPasswordCtrl.hasError('isValidPassword_notStrong')) &&
                                (newPasswordCtrl.touched || myForm.submitted)
                                    ? 'input-error'
                                    : ''
                            "
                            [(ngModel)]="newPassword"
                            name="newPassword"
                            placeholder="{{ 'ResetPassword.EnterNewPassword' | translate }}"
                            required
                            [customValidator]="validatorPassword"
                            #newPasswordCtrl="ngModel"
                        />
                        <mat-error
                            *ngIf="
                                newPasswordCtrl.hasError('required') && (newPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.RequiredNewPassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !newPasswordCtrl.hasError('required') &&
                                newPasswordCtrl.hasError('isValidPassword') &&
                                (newPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.IsValidNewPassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !newPasswordCtrl.hasError('required') &&
                                newPasswordCtrl.hasError('isValidPassword_notStrong') &&
                                (newPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.IsValidNewPassword_notStrong' | translate }}</mat-error
                        >
                    </div>
                    <div class="w-100 p-0 password-input position-relative mb-0">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.62492 18.4583C4.23603 18.4583 3.9027 18.3159 3.62492 18.0312C3.34714 17.7465 3.20825 17.4097 3.20825 17.0208V8.08329C3.20825 7.68051 3.34714 7.34024 3.62492 7.06246C3.9027 6.78468 4.23603 6.64579 4.62492 6.64579H5.97909V4.77079C5.97909 3.64579 6.37145 2.69093 7.15617 1.90621C7.94089 1.12149 8.88881 0.729126 9.99992 0.729126C11.111 0.729126 12.0589 1.12149 12.8437 1.90621C13.6284 2.69093 14.0208 3.64579 14.0208 4.77079V6.64579H15.3749C15.7638 6.64579 16.0971 6.78468 16.3749 7.06246C16.6527 7.34024 16.7916 7.68051 16.7916 8.08329V17.0208C16.7916 17.4097 16.6527 17.7465 16.3749 18.0312C16.0971 18.3159 15.7638 18.4583 15.3749 18.4583H4.62492ZM7.41659 6.64579H12.5833V4.77079C12.5833 4.03468 12.3333 3.41663 11.8333 2.91663C11.3333 2.41663 10.7221 2.16663 9.99992 2.16663C9.2777 2.16663 8.66659 2.41663 8.16659 2.91663C7.66659 3.41663 7.41659 4.03468 7.41659 4.77079V6.64579ZM4.62492 17.0208H15.3749V8.08329H4.62492V17.0208V17.0208ZM9.99992 14.1666C10.4444 14.1666 10.8228 14.0104 11.1353 13.6979C11.4478 13.3854 11.6041 13.0208 11.6041 12.6041C11.6041 12.1875 11.4478 11.809 11.1353 11.4687C10.8228 11.1284 10.4444 10.9583 9.99992 10.9583C9.55547 10.9583 9.177 11.1284 8.8645 11.4687C8.552 11.809 8.39575 12.1875 8.39575 12.6041C8.39575 13.0347 8.552 13.4027 8.8645 13.7083C9.177 14.0138 9.55547 14.1666 9.99992 14.1666Z"
                                fill="#ACACAC"
                            />
                        </svg>
                        <input
                            type="password"
                            class="input-text"
                            [ngClass]="
                                (reNewPasswordCtrl.hasError('required') ||
                                    reNewPasswordCtrl.hasError('isValidPassword') ||
                                    reNewPasswordCtrl.hasError('isValidPassword_notStrong') ||
                                    newPassword != reNewPassword) &&
                                (reNewPasswordCtrl.touched || myForm.submitted)
                                    ? 'input-error'
                                    : ''
                            "
                            [(ngModel)]="reNewPassword"
                            name="reNewPassword"
                            placeholder="{{ 'ResetPassword.Re-enterNewPassword' | translate }}"
                            required
                            [customValidator]="validatorPassword"
                            #reNewPasswordCtrl="ngModel"
                        />
                        <mat-error
                            *ngIf="
                                reNewPasswordCtrl.hasError('required') &&
                                (reNewPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.RequiredReNewPassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !reNewPasswordCtrl.hasError('required') &&
                                reNewPasswordCtrl.hasError('isValidPassword') &&
                                (reNewPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.IsValidReNewPassword' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !reNewPasswordCtrl.hasError('required') &&
                                reNewPasswordCtrl.hasError('isValidPassword_notStrong') &&
                                (reNewPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.IsValidReNewPassword_notStrong' | translate }}</mat-error
                        >
                        <mat-error
                            *ngIf="
                                !reNewPasswordCtrl.hasError('required') &&
                                !reNewPasswordCtrl.hasError('isValidPassword') &&
                                newPassword != reNewPassword &&
                                (reNewPasswordCtrl.touched || myForm.submitted)
                            "
                            >{{ 'ValidationMessage.NotMatchReNewPassword' | translate }}</mat-error
                        >
                    </div>
                    <button mat-button class="btn-sign-in">{{ 'Text_ResetPassword' | translate }}</button>
                    <span class="hidden-md"
                        ><a class="go-back-to-sign-in" href="/login">{{ 'GoBackToSignIn' | translate }}</a></span
                    >
                </form>
            </div>

            <div class="form-control" *ngIf="step == 'verify-code'">
                <h3 class="algin-center font-bold txt-welcome-back">{{ 'VerificationCode.Name' | translate }}</h3>
                <p class="algin-center line-text">{{ 'VerificationCode.EnterEmailVerify' | translate }}</p>
                <p class="algin-center line-text">{{ 'VerificationCode.ThroughEmail' | translate }}</p>
                <form class="form-auth">
                    <form class="form-auth form-submit-code">
                        <code-input
                            [isCodeHidden]="false"
                            [codeLength]="6"
                            [ngClass]="code?.length != 6 && isChangeCode ? 'code-error' : ''"
                            (codeChanged)="onCodeChanged($event)"
                            (codeCompleted)="onCodeCompleted($event)"
                        >
                        </code-input>
                    </form>
                    <mat-error *ngIf="code?.length != 6 && isChangeCode" style="padding-left: 6px">{{
                        'ValidationMessage.RequiredCode' | translate
                    }}</mat-error>
                    <button mat-button class="btn-sign-in" (click)="verifyCode()">{{ 'Submit' | translate }}</button>
                </form>
            </div>

            <div class="warrper-reset successfuly" *ngIf="step == 'reset-success'">
                <div class="warrper-text-image">
                    <div class="image d-flex justify-content-center">
                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M59 30C59 46.0047 46.0169 58.9803 30 58.9803C13.9831 58.9803 1 46.0047 1 30C1 13.9952 13.9831 1.01965 30 1.01965C46.0169 1.01965 59 13.9952 59 30Z"
                                fill="#17B978"
                                stroke="#333333"
                                stroke-width="2"
                            />
                            <path
                                d="M27.5945 45.9469L13.4102 34.8966L17.4433 29.7206L26.1536 36.5063L40.5292 15.7622L45.9236 19.4991L27.5945 45.9469Z"
                                fill="white"
                                stroke="#333333"
                                stroke-width="2"
                            />
                        </svg>
                    </div>
                    <div class="text">
                        <h2 class="font-bold algin-center m-0">{{ 'ResetPassword.MessageSuccess' | translate }}</h2>
                        <h2 class="font-bold algin-center m-0">{{ 'ResetPassword.YourPassword' | translate }}</h2>
                    </div>
                </div>
                <button mat-button class="btn-sign-in m-0" (click)="goBackSignIn()">
                    {{ 'GoBackToSignIn' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="texture-bottom"></div>
</div>
